import { SURVEY } from "../constants/url";
import { catchErrors } from "../utils/catchErrors";
import { getApiCall } from "../utils/servicesBaseUtil";

export const getHomeStoreServiceApi = ({
  data,
  finalCallback,
  successCallback,
}) => {
  return (dispatch) => {
    let url = `${SURVEY}/response?survey_id=${data}`;

    getApiCall({ url: url })
      .then((responseJson) => {
        if (responseJson?.success) {
          successCallback(responseJson);
        }
      })
      .catch((error) => {
        catchErrors(error, url);
      })
      .finally(() => {
        finalCallback();
      });
  };
};
